import React, { useState } from "react"
import styled from "styled-components"
import { media } from "@sr/common"
import { rem } from "polished"
import {
  SemiBdTitle2,
  SemiBdTitle5,
  RegBody,
  IconCheckCircleSolid,
  Button,
} from "@sr/gatsby-theme-ui"
import SanityImage from "gatsby-plugin-sanity-image"
import { Link } from "gatsby"

export interface ProductEntryBenefitsProps {
  benefits: any
  path: string
}

const ProductEntryBenefits = ({
  benefits,
  path,
}: ProductEntryBenefitsProps) => {
  const [selectedButton, setSelectedButton] = useState("Owners")
  const handleButtonClick = (activeInfo: string) => {
    setSelectedButton(activeInfo)
  }
  if (!benefits?.on) return null

  const owners = (ownersData: any) => {

    const img = ownersData?.productEntryBenefitsOwnersImg
    return (
      <div className="benefits__benefits-section-container">
        {img?.asset && (
          <SanityImage
            className="benefits__image"
            asset={img?.asset}
            alt={img?.alt || "alt"}
            hotspot={img?.hotspot}
          />
        )}
        <div className="benefits__benefits-container">
          {ownersData?.productEntryBenefitsOwnersBenefitsList.map(
            (benefit: any, index: number) => (
              <div className="benefits__benefit-container" key={index}>
                <IconCheckCircleSolid />
                <div className="benefits__benefit-text-container">
                  <SemiBdTitle5>{benefit?.title}</SemiBdTitle5>
                  {benefit?.body && <RegBody>{benefit?.body}</RegBody>}
                </div>
              </div>
            )
          )}
          {ownersData?.productEntryBenefitsEnableBtn && (
            <Link
              className="benefits__link"
              to={`${ownersData?.productEntryBenefitsOwnersBtnLink.reference.path.current}#${ownersData?.productEntryBenefitsOwnersBtnLink.anchor}`}
            >
              {" "}
              <Button
                btnColor="var(--color-primary)"
                btnTextColor="var(--color-white)"
              >
                {ownersData?.productEntryBenefitsOwnersBtnText}
              </Button>
            </Link>
          )}
        </div>
      </div>
    )
  }
  const siteTeam = (SiteTeamData: any) => {
    const img = SiteTeamData?.productEntryBenefitsSiteTeamImg
    return (
      <div className="benefits__benefits-section-container">
        {img?.asset && (
          <SanityImage
            className="benefits__image"
            asset={img?.asset}
            alt={img?.alt || "alt"}
            hotspot={img?.hotspot}
          />
        )}
         <div className="benefits__benefits-container">
          {SiteTeamData?.productEntryBenefitsSiteTeamBenefitsList.map(
            (benefit: any, index: number) => (
              <div className="benefits__benefit-container" key={index}>
                <IconCheckCircleSolid />
                <div className="benefits__benefit-text-container">
                  <SemiBdTitle5>{benefit?.title}</SemiBdTitle5>
                  {benefit?.body && <RegBody>{benefit?.body}</RegBody>}
                </div>
              </div>
            )
          )}
          {SiteTeamData?.productEntryBenefitsEnableBtn && (
            <Link
              className="benefits__link"
              to={`${SiteTeamData?.productEntryBenefitsSiteTeamBtnLink.reference.path.current}#${SiteTeamData?.productEntryBenefitsSiteTeamBtnLink.anchor}`}
            >
              {" "}
              <Button
                btnColor="var(--color-primary)"
                btnTextColor="var(--color-white)"
              >
                {SiteTeamData?.productEntryBenefitsSiteTeamBtnText}
              </Button>
            </Link>
          )}
        </div>
      </div>
    )
  }
  const resident = (ResidentData: any) => {
    const img = ResidentData?.productEntryBenefitsResidentImg
    return (
      <div className="benefits__benefits-section-container">
        {img?.asset && (
          <SanityImage
            className="benefits__image"
            asset={img?.asset}
            alt={img?.alt || "alt"}
            hotspot={img?.hotspot}
          />
        )}
        <div>
        <div className="benefits__benefits-container">
          {ResidentData?.productEntryBenefitsResidentBenefitsList.map(
            (benefit: any, index: number) => (
              <div className="benefits__benefit-container" key={index}>
                <IconCheckCircleSolid />
                <div className="benefits__benefit-text-container">
                  <SemiBdTitle5>{benefit?.title}</SemiBdTitle5>
                  {benefit?.body && <RegBody>{benefit?.body}</RegBody>}
                </div>
              </div>
            )
          )}
          {ResidentData?.productEntryBenefitsEnableBtn && (
            <Link
              className="benefits__link"
              to={`${ResidentData?.productEntryBenefitsResidentBtnLink.reference.path.current}#${ResidentData?.productEntryBenefitsResidentBtnLink.anchor}`}
            >
              {" "}
              <Button
                btnColor="var(--color-primary)"
                btnTextColor="var(--color-white)"
              >
                {ResidentData?.productEntryBenefitsResidentBtnText}
              </Button>
            </Link>
          )}
        </div>
        </div>
      </div>
    )
  }

  return (
    <ProductEntryBenefitsStyled>
      <SemiBdTitle2>{benefits?.header}</SemiBdTitle2>
      <div className="benefits__button-container">
        <button
          className={selectedButton === "Owners" ? "selected" : ""}
          onClick={() => handleButtonClick("Owners")}
        >
          Owners
        </button>
        <button
          className={selectedButton === "Site" ? "selected" : ""}
          onClick={() => handleButtonClick("Site")}
        >
          Site Team
        </button>
        <button
          className={selectedButton === "Resident" ? "selected" : ""}
          onClick={() => handleButtonClick("Resident")}
        >
          {path !== "/products/self-guided-tours/" ? "Residents" : "Prospects"}
        </button>
      </div>
      {selectedButton === "Owners" ? owners(benefits?.owners) : null}
      {selectedButton === "Site" ? siteTeam(benefits.siteTeam) : null}
      {selectedButton === "Resident" ? resident(benefits.resident) : null}
    </ProductEntryBenefitsStyled>
  )
}

export default ProductEntryBenefits

const ProductEntryBenefitsStyled = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${rem(112)} ${rem(16)} ${rem(104)};

  @media ${media.midUp} {
    padding: ${rem(168)} ${rem(64)} ${rem(160)};
  }

  @media ${media.stMidUp} {
    padding: ${rem(144)} ${rem(227)} ${rem(184)};
  }

  .benefits__button-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    @media ${media.stMidUp} {
      flex-direction: row;
      justify-content: center;
      max-width: ${rem(842)};
      gap: ${rem(25)};
      margin-top: ${rem(56)};
    }

    button {
      width: 100%;
      cursor: pointer;
      padding: ${rem(16)};
      margin-right: ${rem(8)};
      border: 1px solid transparent;
      box-shadow: none;
      border-radius: ${rem(8)};
      box-shadow: 0px 4px 8px rgba(45, 50, 57, 0.2);
      margin-top: ${rem(24)};
      transition: 0.3s;
      font-size: ${rem(24)};
      font-weight: 600;
      color: var(--color-primary);

      &:first-child {
        margin-top: ${rem(40)};
      }

      @media ${media.stMidUp} {
        margin: 0;
        &:first-child {
          margin: 0;
        }
      }
    }

    button.selected {
      border-color: var(--color-primary);
      box-shadow: 0px 0px 0px rgba(45, 50, 57, 0.2);
    }
  }

  h2 {
    max-width: ${rem(356)};
    text-align: center;

    @media ${media.midUp} {
      max-width: ${rem(616)};
      font-size: ${rem(56)};
      line-height: ${rem(72)};
    }

    @media ${media.stMidUp} {
      max-width: 100%;
    }
  }

  .benefits__benefits-section-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: ${rem(1012)};
 
    @media ${media.stMidUp} {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-top: ${rem(72)};
      gap: ${rem(48)};
    }
  }

  .benefits__image {
    margin-top: ${rem(56)};
    border-radius: ${rem(8)};
    height: ${rem(240)};
    width: 100%;
    object-fit: cover;

    @media ${media.midUp} {
      height: fit-content;
      max-height: ${rem(240)};
    }

    @media ${media.stMidUp} {
      height: ${rem(368)};
      min-height: ${rem(368)};
      width: ${rem(438)};
      min-width: ${rem(438)};
      margin-top: 0;
    }
  }

  .benefits__benefits-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: ${rem(8)};
    padding-top: ${rem(16)};

    @media ${media.stMidUp} {
      width: ${rem(526)};
      max-width: 100%;
      gap: ${rem(32)};
      padding-top: 0;
    }

    .benefits__benefit-container {
      display: flex;

      .benefits__benefit-text-container {
        display: flex;
        flex-direction: column;
      }
      svg {
        min-height: ${rem(26)};
        min-width: ${rem(26)};
        margin-right: ${rem(16)};
        fill: var(--color-primary);
        margin-top: ${rem(2)};
      }
      
      p {
        margin-top: ${rem(8)};
      }
    }
  }
`
